import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Mlb from "./pages/mlb";
import Nba from "./pages/nba";
import Nfl from "./pages/nfl";
import Home from "./pages/home";
import { Navbar } from "./components/Navbar";
import { SignInModal } from "./components/SignInModal";
import { Footer } from "./components/Footer";
import config from "./config";
import { UserProvider } from "./components/UserProvider";
import { ActivationPage } from './components/ActivationPage';
import NotFound from './pages/notfound';
import ContestResults from './pages/contestresults';
import NbaContestResults from './pages/nbacontestresults';
import { IntercomChat } from "./components/IntercomChat";
import theme from "./theme";

const apiUrl = `${config.apiUrl}`

function App() {

  const [openModal, setOpenModal] = React.useState('none');
  const handleOpen = () => setOpenModal('sign-in');
  const handleClose = () => setOpenModal('none');

  return (
    <UserProvider apiUrl={apiUrl} setOpenModal={setOpenModal}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SignInModal openModal={openModal} handleClose={handleClose} setOpenModal={setOpenModal} />
        <IntercomChat />
        <Router>
          <Navbar handleOpen={handleOpen} />
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path='/activate/:token' element={<ActivationPage />} />
            <Route path='/mlb' element={<Mlb />} />
            <Route path='/nba' element={<Nba />} />
            <Route path='nfl' element={<Nfl />} />
            <Route path='/mlb/contest-results' element={<ContestResults />} />
            <Route path='/nba/contest-results' element={<NbaContestResults />} />
            <Route path='*' Component={NotFound} />
          </Routes>
          <Footer />
        </Router>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
